






































































































































































































































































































































































































































































































































































import { AxiosResponse } from "axios";
import { Dictionary } from "lodash";
import moment from "moment";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import {
  ApiMessage,
  CustomersApi,
  LocationsApi,
  PostTreatmentRequestRequest,
  PutTreatmentRequestRequest,
  RpasApi,
  TreatmentDatabaseModel,
  TreatmentDatabasesApi,
  TreatmentMasterListsApi,
  TreatmentRequestsApi,
  UnitsApi,
  VariablesApi,
} from "../../../apis";
import AddSetpointDialog from "./AddSetpointDialog.vue";
import { required } from "vee-validate/dist/rules";
import { ITreatmentTimeOption } from "./";
import { orderBy } from "lodash";

enum ACTION {
  NEW = "NEW",
  EDIT = "EDIT",
  VIEW = "VIEW",
}
@Component({
  components: { ValidationObserver, ValidationProvider, AddSetpointDialog },
})
export default class AddTreatmentRequest extends Vue {
  currentMode: ACTION = null;
  selectedID: string;
  treatmentReq = {} as any;
  isViewMode = false;
  isEditMode = false;
  isNewMode = false;
  rpaId = null;
  rpas = [];
  treatmentTimeSelected: ITreatmentTimeOption = null;
  expiryTime = null;

  isShowProductDialog = false;
  readonly NEW = ACTION.NEW;
  readonly EDIT = ACTION.EDIT;

  setPointOptions = [];
  setPointOptionsData = [];

  //General Options
  customerOptions = [];
  locationOptions = [];
  treatmentTypeOptions = [
    { value: "Normal", name: this.$t("text.Normal") },
    { value: "Special", name: this.$t("text.Special") },
  ];

  //Product Information
  productOptions = [];
  packageOptions = [];
  techniqueOptions = [];
  formatTimeOptions = [
    { value: "MINUTES", text: this.$t("text.MINUTES") },
    { value: "HOURS", text: this.$t("text.HOURS") },
    { value: "DAYS", text: this.$t("text.DAYS") },
    { value: "WEEKS", text: this.$t("text.WEEKS") },
    { value: "MONTHS", text: this.$t("text.MONTHS") },
  ];

  treatmentTimeOptions: Array<ITreatmentTimeOption> = [];

  //Unit Information
  unitOptions = [];
  variableOptions = [];

  // Status options for finished/cancelled requests
  get finishedStatusOptions() {
    return [
      { value: "Finished", name: this.$t("text.finished") },
      { value: "Cancelled", name: this.$t("text.cancelled") },
    ];
  }

  // Check if user can edit finished/cancelled request fields
  get canEditFinishedRequest() {
    return this.isEditMode && 
           this.isFinished(this.treatmentReq.status) && 
           (this as any).$hasPermission({ context: 'TREATMENT_MANAGEMENT|EDIT_FINISHED_REQUEST', action: 'update' });
  }

  itemsSetPoint = [];

  hiddenValue = "*";
  productsSplit = [];

  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;

  created() {
    this.currentMode = this.$route.meta.mode as ACTION;
    if (this.currentMode === ACTION.EDIT || this.currentMode === ACTION.VIEW) {
      this.selectedID = this.$route.params.id;
    }
    this.isViewMode = this.currentMode === ACTION.VIEW;
    this.isEditMode = this.currentMode === ACTION.EDIT;
    this.isNewMode = this.currentMode === ACTION.NEW;
  }

  get isSpecialTreatment() {
    return this.treatmentReq.treatmentType === "Special";
  }
  pushNewProduct(productsName) {
    this.treatmentReq.weights.push({
      productName: productsName.trim(),
      totalWeight: null,
      lotNumber: '',
      packaging: '',
      specification: '',
      numberOfPackages: null,
      numberOfPallets: null,
    });
  }

  removeProduct(productName) {
    const index = this.treatmentReq.weights.findLastIndex(w=> w.productName == productName.trim());
    this.treatmentReq.weights.splice(index, 1);
  }
  filterProduct(productName) {
    return this.treatmentReq.weights ? this.treatmentReq.weights.filter(w=> w.productName == productName.trim()) : [];
  }
  isInprogress(status: string) {
    return ["In Progress", "Cancelled", "Finished", "Cancelled O2up", "Finished O2up"].includes(status);
  }
  isFinished(status: string) {
    return ['Cancelled', 'Finished'].includes(status);
  }

  mounted() {
    this.initForm();
  }

  async initForm() {
    //get current mode
    const typeSetpoint = "setpoint";
    const isActive = (val): boolean => val.status === "Active";

    let treatmentsRes;
    let customersRes;

    try {
      this.$util.showLoading();
      [ treatmentsRes, customersRes ] = await Promise.all([
        new TreatmentMasterListsApi().getTreatmentsByType({
          typetreatment: "setpoint",
        }),
        new CustomersApi().getAllCustomerByStringAndStatus({
          keyword: "",
          status: "Active",
        }),
      ]);
    } catch (error) {
      this.$util.showError(error);
      return;
    } finally {
      this.$util.hideLoading();
    }

    // dropdown builder
    this.customerOptions = customersRes.data.data;

    this.setPointOptionsData = treatmentsRes.data.data
      .filter((treatment) => treatment.treatmentType === typeSetpoint)
      .reverse();

    if (
      (this.currentMode === ACTION.EDIT || this.currentMode === ACTION.VIEW) &&
      this.selectedID
    ) {
      await this.onGetTreatmentRequestById(this.selectedID);
    } else {
      this.treatmentReq = {} as PostTreatmentRequestRequest;
      this.treatmentReq.startDate = moment(new Date()).add(5, 'm').format('YYYY-MM-DD HH:mm');
    }
  }

  async onGetTreatmentRequestById(selectedID) {
    let treatmentById;
    try {
      this.$util.showLoading();
      treatmentById = await new TreatmentRequestsApi().getTreatmentRequest({
        id: selectedID,
      });
    } catch (error) {
      this.$util.showError(error);
      return;
    } finally {
      this.$util.hideLoading();
    }
    [ this.treatmentReq ] = treatmentById.data.data;
    if (this.isEditMode || this.isViewMode) {
      this.rpaId = this.treatmentReq.rpa;
    }
    this.treatmentReq.startDate = this.treatmentReq.startDate? moment(this.treatmentReq.startDate).format(
      "YYYY-MM-DD HH:mm"
    ): this.treatmentReq.startDate;
    this.treatmentReq.endDate = this.treatmentReq.endDate? moment(this.treatmentReq.endDate).format(
      "YYYY-MM-DD HH:mm"
    ): this.treatmentReq.endDate;
    this.treatmentReq.expectedEndDate = this.treatmentReq.expectedEndDate? moment(this.treatmentReq.expectedEndDate).format(
      "YYYY-MM-DD HH:mm"
    ):this.treatmentReq.expectedEndDate;
    if (this.treatmentReq.autoStopDate)
      this.treatmentReq.autoStopDate = moment(
        this.treatmentReq.autoStopDate
      ).format("YYYY-MM-DD HH:mm");
    this.treatmentReq.reachingO2Level = this.treatmentReq.reachingO2Level? moment(this.treatmentReq.reachingO2Level).format(
      "YYYY-MM-DD HH:mm"
    ): this.treatmentReq.reachingO2Level;
    this.treatmentReq.reachingProductTemp = this.treatmentReq.reachingProductTemp? moment(this.treatmentReq.reachingProductTemp).format(
      "YYYY-MM-DD HH:mm"
    ): this.treatmentReq.reachingProductTemp;
    await Promise.all([
      this.onChangeCustomer(),
      this.onChangeLocation(),
      this.onChangeUnit(),
      this.onChangeProduct(),
      this.onChangePackage(),
      this.onChangeTechnique(),
    ]).then(() => this.onChangeTreatmentTimeSelected());
    this.doApplySetPointOptions();
  }

  doApplySetPointOptions() {
    this.setPointOptions = [ ...this.setPointOptions ].map((setPoint) => {
      const tmp = this.treatmentReq.setPoint.find(
        (treatmentReqSetPoint) => treatmentReqSetPoint.id === setPoint.id
      );
      const variable = tmp ? tmp.variable : {};
      const actualVariable = tmp ? tmp.actualVariable : {};
      this.variableOptions = this.variableOptions.map((variableOption) => {
        if (variable === variableOption.id) {
          return { ...variableOption, disabled: true };
        }
        if (actualVariable === variableOption.id) {
          return { ...variableOption, disabled: true };
        }
        return { ...variableOption };
      });
      return { ...setPoint, variable, actualVariable };
    });
  }

  resetVariableBySetPointOptions() {
    this.setPointOptions.forEach((setPoint) => {
      delete setPoint.variable;
    });
  }

  resetDisableVariableOptions() {
    this.variableOptions = this.variableOptions.map((variableOption) => {
      return { ...variableOption, disabled: false };
    });
  }

  get saveTreatmentClick() {
    return this.$store.getters.saveTreatmentRequestClick;
  }

  @Watch("saveTreatmentClick")
  onSaveTreatmentClick() {
    this.onSubmit();
  }

  async onSubmit() {
    const isValid = await this.observer.validate();
    if (!isValid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    this.$util.showLoading();
    await this.doSubmit()
      .then((res) => this.handleSuccess())
      .catch((err) => this.handleFailed(err));
    this.$util.hideLoading();
  }

  invalidMsgStartDate = null;
  invalidMsgEndDate = null;

  doCheckValidDate(): boolean {
    const startDate = moment(this.treatmentReq.startDate);
    const endDate = moment(this.treatmentReq.endDate);
    const currentDate = moment(new Date());
    if (
      !this.isInprogress(this.treatmentReq.status) &&
      startDate < currentDate
    ) {
      this.invalidMsgStartDate = this.$t("message.invalid_start_date");
      return false;
    }
    if (startDate > endDate) {
      this.invalidMsgEndDate = this.$t("message.invalid_end_date");
      return false;
    }
    this.invalidMsgStartDate = "";
    this.invalidMsgEndDate = "";
    return true;
  }

  doSubmit(): Promise<AxiosResponse> {
    const formatDate = (dateStr) =>
      moment(dateStr, "YYYY-MM-DD HH:mm").utc().format("YYYY-MM-DD HH:mm");
    const body: PutTreatmentRequestRequest | PostTreatmentRequestRequest = {
      ...this.treatmentReq,
      insects: this.treatmentReq.insects.map((insect) => insect.id),
      setPoint: this.setPointOptions.map((setPoint) => {
        return {
          id: setPoint.id,
          value: setPoint.value,
          variable: (setPoint.variable && setPoint.variable.id) ? setPoint.variable.id : setPoint.variable,
          actualVariable: (setPoint.actualVariable && setPoint.actualVariable.id) ? setPoint.actualVariable.id : setPoint.actualVariable,
        };
      }),
      startDate: formatDate(this.treatmentReq.startDate),
      endDate: formatDate(this.treatmentReq.endDate),
      expectedEndDate: this.treatmentReq.expectedEndDate ? formatDate(this.treatmentReq.expectedEndDate) : undefined,
      reachingO2Level: this.treatmentReq.reachingO2Level ? formatDate(this.treatmentReq.reachingO2Level) : undefined,
      reachingProductTemp: this.treatmentReq.reachingProductTemp ? formatDate(this.treatmentReq.reachingProductTemp) : undefined,
      treatmentTime: +this.treatmentReq.treatmentTime,
      treatmentFormat: this.treatmentReq.treatmentFormat,
      expiryTime: this.treatmentReq.expiryTime ? +this.treatmentReq.expiryTime : undefined,
      expiryFormat: this.treatmentReq.expiryFormat,
      totalWeight: +this.treatmentReq.totalWeight,
      lotNumber: this.treatmentReq.lotNumber,
      numberOfPackages: +this.treatmentReq.numberOfPackages,
      freeTimes: +this.treatmentReq.freeTimes,
      numberOfPallets: +this.treatmentReq.numberOfPallets,
      autoStopDate: !this.treatmentReq.autoStopDate
        ? ""
        : formatDate(this.treatmentReq.autoStopDate),
      weights: this.treatmentReq.weights,
      specialRequest: this.treatmentReq.treatmentType == 'Normal' ? null : this.treatmentReq.specialRequest,
      createdAt: undefined,
      createdBy: undefined,
      updatedAt: undefined,
      updatedBy: undefined,
      rpa: this.rpaId
    };
    if (this.currentMode === ACTION.EDIT && this.selectedID) {
      return new TreatmentRequestsApi().updateTreatmentRequest({
        id: this.selectedID,
        putTreatmentRequestRequest: body as PutTreatmentRequestRequest,
      });
    } else {
      return new TreatmentRequestsApi().createTreatmentRequest({
        postTreatmentRequestRequest: body as PostTreatmentRequestRequest,
      });
    }
  }

  getRouteCancel() {
    this.$router.push({ name: "treatment-request" });
  }

  handleSuccess() {
    this.getRouteCancel();
  }

  handleFailed(err) {
    this.$util.showError(err);
  }

  get apiMessages(): Dictionary<ApiMessage[]> {
    return this.$store.getters.apiMessages;
  }

  @Watch("apiMessages", { deep: true })
  apiMessagesWatch(messages: Dictionary<ApiMessage[]>) {
    this.$util.showApiError(messages, this.observer);
  }

  async onChangeCustomer() {
    this.locationOptions = [];
    this.unitOptions = [];
    if (!this.treatmentReq.customerId) return;
    try {
      this.$util.showLoading();
      const res = await new CustomersApi().getActiveLocationsByCustomerId({
        id: this.treatmentReq.customerId,
      });
      this.locationOptions = res.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onChangeLocation() {
    this.unitOptions = [];
    this.productOptions = [];
    if (!this.treatmentReq.location) return;
    try {
      this.$util.showLoading();
      const [ unitsRes, productsRes ] = await Promise.all([
        new UnitsApi().getUnitByLocationId({
          locationId: this.treatmentReq.location,
        }),
        new TreatmentDatabasesApi().getProductsInTreatmentDataBase({
          locationId: this.treatmentReq.location,
        }),
      ]);
      this.unitOptions = unitsRes.data.data;
      this.unitOptions = this.unitOptions ? this.unitOptions.filter(u => !u[ 'noneTreatment' ]) : [];
      this.productOptions = productsRes.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onChangeUnit() {
    this.variableOptions = [];
    this.resetVariableBySetPointOptions();
    if (!this.treatmentReq.unit) return;
    try {
      this.$util.showLoading();
      const rpaRes = await new RpasApi().getRpaByUnit({
        unitId: this.treatmentReq.unit,
      });
      if (rpaRes.data.data) {
        this.rpas = [ { value: rpaRes.data.data.id, text: rpaRes.data.data.rpaName } ];
        // this.treatmentReq.rpa = rpaRes.data.data.id;
      }
      const variablesRes = await new VariablesApi().getVariablesByUnitIdSoredOrder({
        id: this.treatmentReq.unit,
      });
      this.variableOptions = variablesRes.data.data.map((variable) => {
        return {
          ...variable,
          variableName: `${variable.variableName} - ${variable.memory} - ${variable.controller}`,
        };
      });
      this.populateSetpoint();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onChangeProduct() {
    this.packageOptions = [];
    this.techniqueOptions = [];
    this.treatmentTimeOptions = [];
    this.treatmentTimeSelected = null;
    this.treatmentReq.insects = [];
    this.setPointOptions = [];
    if (!this.treatmentReq.product) return;
    try {
      this.$util.showLoading();
      const res =
        await new TreatmentDatabasesApi().getPackageFromProductInTreatmentDataBase(
          {
            id: this.treatmentReq.product,
            locationId: this.treatmentReq.location
          }
        );
      this.packageOptions = res.data.data;
      if (this.treatmentReq.package) {
        const {
          data: { data: techniqueOptions },
        } = await new TreatmentDatabasesApi().getTechnniqueFromProductAndPackageInTreatmentDataBase(
          {
            locationId: this.treatmentReq.location,
            productId: this.treatmentReq.product,
            packageId: this.treatmentReq.package,
          }
        );
        this.techniqueOptions = techniqueOptions;
      }
      const productSelected = this.productOptions.find(prod => prod.id === this.treatmentReq.product);
      this.productsSplit = productSelected.product.split(",");
      if (this.currentMode === ACTION.NEW) {
        this.weightsBuilder(this.productsSplit);
      }
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onChangePackage() {
    this.techniqueOptions = [];
    this.treatmentTimeOptions = [];
    this.treatmentTimeSelected = null;
    this.treatmentReq.insects = [];
    this.setPointOptions = [];
    if (!this.treatmentReq.product || !this.treatmentReq.package) return;
    try {
      this.$util.showLoading();
      const res =
        await new TreatmentDatabasesApi().getTechnniqueFromProductAndPackageInTreatmentDataBase(
          {
            locationId: this.treatmentReq.location,
            productId: this.treatmentReq.product,
            packageId: this.treatmentReq.package,
          }
        );
      this.techniqueOptions = res.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onChangeTechnique() {
    this.treatmentTimeOptions = [];
    this.treatmentTimeSelected = null;
    this.treatmentReq.insects = [];
    this.setPointOptions = [];
    if (
      !this.treatmentReq.product ||
      !this.treatmentReq.package ||
      !this.treatmentReq.technique
    )
      return;
    try {
      this.$util.showLoading();
      await new TreatmentDatabasesApi()
        .getAllFromProductAndPackageAndTechniqueInTreatmentDataBase({
          locationId: this.treatmentReq.location,
          productId: this.treatmentReq.product,
          packageId: this.treatmentReq.package,
          techniqueId: this.treatmentReq.technique,
        })
        .then((response) => {
          const treatmentDatabase: TreatmentDatabaseModel[] =
            response.data.data;
          this.treatmentTimeOptions = treatmentDatabase.map((val, idx) => ({
            ...val,
            text: `${val.treatmentTime} ${this.$t(`text.${val.treatmentFormat}`)}`
          }));
        })
        .then(() => {
          if (this.currentMode === ACTION.EDIT || this.currentMode === ACTION.VIEW) {
            this.treatmentTimeSelected = this.treatmentTimeOptions.find(
              (opt) =>
                opt.treatmentTime === this.treatmentReq.treatmentTime &&
                opt.treatmentFormat.toUpperCase() === this.treatmentReq.treatmentFormat.toUpperCase()
            );
          }
        });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onChangeTreatmentTimeSelected() {
    this.treatmentReq.insects = [];
    this.setPointOptions = [];
    if (
      !this.treatmentReq.product ||
      !this.treatmentReq.package ||
      !this.treatmentReq.technique ||
      !this.treatmentTimeSelected
    )
      return;
    try {
      this.$util.showLoading();
      await new TreatmentDatabasesApi()
        .getAllFromProductAndPackageAndTechniqueAndTimeInTreatmentDataBase({
          locationId: this.treatmentReq.location,
          productId: this.treatmentReq.product,
          packageId: this.treatmentReq.package,
          techniqueId: this.treatmentReq.technique,
          treatmentTime: this.treatmentTimeSelected.treatmentTime,
          treatmentFormat: this.treatmentTimeSelected.treatmentFormat,
        })
        .then((response) => {
          const [ treatmentDatabase ]: TreatmentDatabaseModel[] =
            response.data.data;
          this.treatmentReq = {
            ...this.treatmentReq,
            treatmentTime: treatmentDatabase.treatmentTime,
            treatmentFormat: treatmentDatabase.treatmentFormat,
            insects: treatmentDatabase.insects,
            isPallet: treatmentDatabase.isPallet,
            expiryTime: treatmentDatabase.expiryTime,
            expiryFormat: treatmentDatabase.expiryFormat,
          };
          //set expiry time for display
          this.expiryTime = (treatmentDatabase.expiryTime && treatmentDatabase.expiryFormat)
            && `${treatmentDatabase.expiryTime} ${this.$t(`text.${treatmentDatabase.expiryFormat}`)}`,
            treatmentDatabase.setPoint.forEach((setPoint) => {
              const setPointFound = this.setPointOptionsData.find(
                (setPointData) => setPointData.id === setPoint[ "id" ]
              );
              this.setPointOptions.push({
                ...setPointFound,
                value: setPoint[ "value" ],
              });
            });
          this.resetDisableVariableOptions();
          this.populateSetpoint();
        });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
      this.onChangeUnit();
    }
  }

  onChangeVariable(index: number) {
    this.doSetDisableVariableOptions();
  }

  variableCleared(index: number) {
    this.doSetDisableVariableOptions();
  }

  isHiddenAirTemptAndInletTemp(code): boolean {
    return this.$util.isClient() && [ 'AIR_TEMP', 'INLET_TEMP' ].includes(code);
  }

  getProducts() {
    if (!this.treatmentReq.product) {
      return [];
    }
    const { product }: { product: string } = this.lodash.find(this.productOptions, val => val.id === this.treatmentReq.product);
    if (!product) {
      return [];
    }
    return product.split(",");
  }

  weightsBuilder(productsName) {
    this.treatmentReq.weights = [];
    for (let idx = 0; idx < productsName.length; idx++) {
      this.treatmentReq.weights.push({
        productName: productsName[ idx ] ? productsName[ idx ].trim() : "",
        totalWeight: null,
        lotNumber: '',
        specification: '',
        numberOfPackages: null,
        numberOfPallets: null,
      });
    }
  }

  populateSetpoint() {
    if (this.currentMode !== "VIEW" && !this.lodash.isEmpty(this.variableOptions)) {
      this.setPointOptions.forEach((setpoint, index) => {
        if (this.variableOptions.length > index) {
          setpoint.variable = this.variableOptions[ index ];
          setpoint.actualVariable = this.variableOptions[ index + this.setPointOptions.length ];
        }
      });
      this.doSetDisableVariableOptions();
    }
  }

  doSetDisableVariableOptions() {
    const selectedVariableIds =
      this.setPointOptions
        .map(setPoint => setPoint.variable ? setPoint.variable.id || setPoint.variable : "");
    const selectActualVariableIds = this.setPointOptions
      .map(setPoint => setPoint.actualVariable.id || setPoint.actualVariable);
    this.variableOptions.forEach(variableOpt => {
      if (selectedVariableIds.includes(variableOpt.id) || selectActualVariableIds.includes((variableOpt.id))) {
        variableOpt.disabled = true;
      } else {
        variableOpt.disabled = false;
      }
    });
  }
}
